import { useTranslation } from "@opendash/i18n";
import { Form, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { TicketMetaFieldTypes } from "../../../../../tickets/_shared/types/TicketMeta";
import { PathContext } from "../../../context/PathContext";

type Props = {};

export const MetaFieldTypeSelect = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <Form.Item
      label={t("maintenance:ticket_creation.fields.meta.fields.type")}
      name={[...path, "type"]}
      style={{ width: "100%" }}
    >
      <Select
        options={TicketMetaFieldTypes.map((type) => ({
          value: type,
          label: t(`maintenance:ticket_creation.fields.meta.types.${type}`),
        }))}
      />
    </Form.Item>
  );
});
